<template>
    <div class="system">
      <div class="return" v-if="clienId" @click="back">
        <img class="backImg" src="@/assets/images/back.png" alt />
      </div>
      <div class="top">
        <div class="title">
          <i class="el-icon-collection-tag" />基本资料
        </div>
        <div style="text-align: right;">
        </div>
  
      </div>
      <el-descriptions class="margin-top" :column="4" border>
        <el-descriptions-item>
          <template slot="label">销售部门</template>
          {{detail.shop_name}}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">客户姓名</template>
          {{detail.consignee}}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">订单单号</template>
          {{detail.refund_order_no}}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">类型</template>
          <span >退货单--单品退</span>
        </el-descriptions-item> 
        <el-descriptions-item v-if="noKing == 1">
          <template slot="label">开单员姓名</template>
          {{detail.sale_name}}
        </el-descriptions-item>
        <el-descriptions-item  v-else>
          <template slot="label">录单员姓名</template>
          {{detail.operator_name}}
        </el-descriptions-item>
        <!-- <el-descriptions-item>
          <template slot="label">业务类型</template>
          {{detail.business_type}}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">业务类型二级分类</template>
          {{detail.business_two_type_text}}
        </el-descriptions-item> -->
        <el-descriptions-item>
          <template slot="label">订单类型</template>
          {{detail.order_type}}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">订单分类</template>
          {{detail.order_class_text}}
        </el-descriptions-item>

        <el-descriptions-item>
            <template slot="label">金蝶单号</template>
            {{detail.king_num?detail.king_num:'暂无'}}
          </el-descriptions-item>

        <el-descriptions-item>
          <template slot="label">退货总计</template>
          {{detail.total_amount}}
        </el-descriptions-item>

        <el-descriptions-item>
          <template slot="label">退货本金</template>
          {{detail.pay_amount}}
        </el-descriptions-item>

        <el-descriptions-item >
          <template slot="label">退货赠金</template>
          {{detail.gift_amount}}
        </el-descriptions-item>
       
        <el-descriptions-item>
          <template slot="label">退货店转</template>
          {{detail.shop_transfer_amount}}
        </el-descriptions-item>

        <el-descriptions-item>
          <template slot="label">成交时间</template>
          {{detail.deal_time?detail.deal_time:'暂无'}}
        </el-descriptions-item>
        
      
        <el-descriptions-item>
          <template slot="label">创建时间</template>
          {{detail.create_time?detail.create_time:'暂无'}}
        </el-descriptions-item>

        <el-descriptions-item>
          <template slot="label">金蝶推送状态</template>
          <span v-if="detail.king_status == 0">默认</span>
          <span v-if="detail.king_status == 1">成功</span>
          <span v-if="detail.king_status == 2">失败</span>
          <span v-if="detail.king_status == 5">登陆失败</span>
        </el-descriptions-item>

        <el-descriptions-item >
          <template slot="label">订单状态</template>
          {{detail.status_msg}}
        </el-descriptions-item>
      
      
        <el-descriptions-item  >
          <template slot="label">收入类型</template>
          <span v-if="detail.income_type == 1">服务（各类疗程卡项及疗程卡项赠送产品）</span>
          <span v-if="detail.income_type == 2">产品销售（单独付费购买产品）</span>
          <span v-if="detail.income_type == 3">医美收入</span>
        </el-descriptions-item>

        <el-descriptions-item>
          <template slot="label">订单描述</template>
          {{detail.description?detail.description:'暂无'}}
        </el-descriptions-item>
  
      </el-descriptions>
      <div class="top">
        <div class="title mt20">
          <i class="el-icon-collection-tag" />
          <span>退货商品资料</span>
        </div>
      </div>
      <!--列表-->
      <el-row>
        <el-col :span="24">
          <el-table
            :data="list"
            size="small"
            border
            :cell-style="$style.cellStyle"
            :header-cell-style="$style.rowClass"
            default-expand-all
            :row-style="setRowStyle"
          >
          <el-table-column type="expand" width="50" border >
                <template slot-scope="props" >
                  <div v-if="props.row.service_goods_str && props.row.goods_type == 1">
                    <el-table   :data="props.row.service_goods_str" :fit="true" :row-key="(row) => row.id" :show-header="false"   border  class="table_body"  >
                      <el-table-column width="50"  />
                      <el-table-column width="260" prop="name"  align="center"  />
                      <el-table-column width="300"  prop="goods_alias_name"  align="center" />
                    </el-table>
                  </div>
                </template>
            </el-table-column>
  
            <ElTableColumn label="商品名称" prop="goods_name" />
            <ElTableColumn label="商品名称-别名" prop="goods_alias_name" />
            <ElTableColumn label="商品含税单价" prop="pay_price" />
            <ElTableColumn label="商品规格金蝶编码" prop="kingdee_code" />
            <ElTableColumn label="是否赠品">
              <template slot-scope="{ row }">
                <span v-if="row.is_gift == '0'">否</span>
                <span v-if="row.is_gift == '1'">是</span>
              </template>
            </ElTableColumn>
            <ElTableColumn label="仓库编码" prop="house_code" />
            <ElTableColumn label="退款业务类型" prop="data_business_type_text" />
            <ElTableColumn label="是否退预存货" prop="is_refund_prestock" />
            <ElTableColumn label="退货数量" prop="return_num" />
            <ElTableColumn label="退货款本金" prop="refund_principal_price" />
            <ElTableColumn label="退款款赠金" prop="gift_price" />
            <ElTableColumn label="退货款店转" prop="shop_transfer_price" />
            <ElTableColumn label="商品退款描述" prop="descs" />
           
          </el-table>
        </el-col>
      </el-row>
    </div>
  </template>
  
  <script>
  import { refundDetail, orderRefundDetail,delRefundOrder,addTurnRefund,refundOneOrderDetail,refundOneOrderGoodsDetail} from "@/api/order";
  import { balanceRegainApply,auditDetail } from "@/api/serviceConsume";
  class applyDetail {
      remark = '';
    }
  export default {
    name: "system",
    data() {
      return {
        system: {},
        remark: "",
        detail: [],
        list: [],
        type: "",
        clienId: "",
        activeName: "",
        dialogVisible: false,
        form: {},
        formLabelWidth:'120px',
        noKing:'',
        isShowProjectType:false,
        isShowRefundAccount:false,
        isShowRefunder:false,
        regianApplyPop:false,
        applyPop:false,
        auditDetailList:[],
        auditDetail:{},
        applyDetail: new applyDetail()
      };
    },
    mounted() {
      this.type = this.$route.query.type;
      this.activeName = this.$route.query.activeName;
      this.clienId = this.$route.query.clienId;
      this.noKing = this.$route.query.noKing;
      this.getDetail();
  
    },
    methods: {
      setRowStyle({ row }) {
        return row.goods_type === 1 
          ? { '--expand-color': 'black' } 
          : { '--expand-color': 'white' };
      },
      // 获取详情
      getDetail() {
        refundOneOrderDetail({
          order_id: this.$route.query.id,
          type: this.$route.query.type
        }).then(res => {
          this.detail = res;
          console.log(this.detail,'订单详情')
          if(this.detail.type==2){
            this.isShowProjectType = true;
          }
          if(this.detail.type==1){
            this.isShowRefundAccount = true;
            this.isShowRefunder = true;
          }
        });
        refundOneOrderGoodsDetail({
          order_id: this.$route.query.id,
          type: this.$route.query.type
        }).then(res => {
          console.log(res.goodsList);
          this.list = res.goodsList;
        });
      },
      // 返回
      back() {
        console.log(this.$route.query.activeName,"this.$route.query.activeName")
        const query = {
          id: this.$route.query.clienId,
          customer_name: this.$route.query.detail.customer_name,
          detail:this.$route.query.detail,
          activeName: this.$route.query.activeName,
          activeTab: this.$route.query.activeTab,
        };
        this.$router.push({ name: "客户详情", query });
      },
  
    
  
    }
  };
  </script>
  
  <style lang='scss' scoped>
  ::v-deep .el-table__expand-icon {
    color: var(--expand-color, #909399) !important;
  }
  .return {
    position: fixed;
    right: 20px;
    top: 71px;
    z-index: 999;
    .backImg {
      margin-right: 14px;
      width: 32px;
      height: 100%;
      cursor: pointer;
      vertical-align: middle;
    }
  }
  .top {
    display: flex;
    justify-content: space-between;
    .title {
      font-weight: bold;
      font-size: 14px;
      line-height: 34px;
      color: #666;
    }
  }
  ::v-deep .el-descriptions-item__label.is-bordered-label {
    background: #f9fafc;
  }
  
  </style>
  